import { Component, OnInit, Inject, Input, Output } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MDCDialog } from '@material/dialog';
import { environment } from "../../environments/environment";
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-custom-dialog',
  templateUrl: './custom-dialog.component.html',
  styleUrls: ['./custom-dialog.component.scss']
})
export class CustomDialogComponent implements OnInit {
  @Input() title1: any;
  @Input() title2: any;
  @Input() description: any;
  @Input() description2: any
  @Output() onCloseClick: EventEmitter<string> = new EventEmitter();
  private dialog = null;
  public campaignConstants = null;
  constructor(@Inject(DOCUMENT) private document: Document) {

  }

  ngOnInit(): void {
    this.load();
    this.dialog = new MDCDialog(this.document.querySelector('#mdc-dialog'));
    this.dialog.open();
  }

  close() {
    this.dialog.close();
    this.onCloseClick.emit('true')
  }

  load = async () => {
    const constants = await import(`../../${environment.CAMPAIGN_NAME}/constant.js`);
    this.campaignConstants = constants.default;
  };

}
